import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Building2, Radius as Stadium, School, Wrench } from 'lucide-react';

export function ServicesPage() {
  const { t } = useLanguage();

  const services = [
    {
      icon: Building2,
      title: 'services.categories.commercial.title',
      description: 'services.categories.commercial.description',
      features: ['services.features.commercial'],
    },
    {
      icon: Stadium,
      title: 'services.categories.special.title',
      description: 'services.categories.special.description',
      features: ['services.features.special'],
    },
    {
      icon: School,
      title: 'services.categories.institutional.title',
      description: 'services.categories.institutional.description',
      features: ['services.features.institutional'],
    },
    {
      icon: Wrench,
      title: 'services.categories.specialized.title',
      description: 'services.categories.specialized.description',
      features: ['services.features.specialized'],
    },
  ];

  return (
    <div className="bg-gray-50">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            {t('services.title')}
          </h1>
          <p className="mt-4 text-xl text-gray-600">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="mt-20">
          {services.map(({ icon: Icon, title, description, features }) => (
            <div
              key={title}
              id={t(title).toLowerCase()}
              className="mb-16 bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="p-8">
                <div className="flex items-center">
                  <Icon className="h-8 w-8 text-blue-900" />
                  <h2 className="ml-4 text-2xl font-bold text-gray-900">
                    {t(title)}
                  </h2>
                </div>
                <p className="mt-4 text-lg text-gray-600">
                  {t(description)}
                </p>
                <ul className="mt-8 space-y-4">
                  {features.map((feature) => (
                    <li key={feature} className="flex items-center">
                      <span className="h-2 w-2 bg-blue-900 rounded-full mr-3" />
                      <span className="text-gray-600">{t(feature)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}